import React, {useState} from 'react';
import {Button, Col, Container, Form, Image, InputGroup, Row} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './ExchangeCodes.css';
import ApiService from "../../api/ApiService";
import LocalDataService from "../../api/LocalDataService";
import {toast} from "react-toastify";

const ExchangeCodes = () => {

    const api = new ApiService();
    const [code, setCode] = useState('');

    async function changeCode() {
        // 获取输入框的兑换码值
        console.log('输入的兑换码:', code);
        if (!code){
            toast.error('请输入兑换码');
            return;
        }
        var result = await api.vipCodeChange(code);
        if (result.code === 200) {
            toast.success('兑换成功');
            const user = await api.get_user_info();
            console.log('Logged in user:', user);
            //更新用户信息
            LocalDataService.set_user_data(user.data);
            // 触发用户状态更新事件
            window.dispatchEvent(new Event('userLoginStatusChanged'));
        }else {
            toast.error(result.msg);
        }

    }

    return (
        <Container className="mt-4">
            <Row>
                <Col md={12}>
                    <div className="exchange-code-container">
                        <div className={'d-flex align-items-center header-container'}>
                            <Image src={"/images/vip/vip_code_gift.svg"} width={'32px'} className="icon"/><span
                            className="title">兑换礼品码（激活码）</span>
                        </div>
                        <Row className={'p-4 p-md-2'}>
                            <Col lg={8} md={12} style={{textAlign: 'left'}}>
                                <Form>
                                    <InputGroup className="mb-3">
                                        <Form.Control placeholder="请输入兑换码" className="form-control"
                                                      value={code}
                                                      onChange={(e) => setCode(e.target.value)}/>
                                        <InputGroup.Text className="input-group-text" onClick={() => {
                                            changeCode()
                                        }}>
                                            兑换
                                        </InputGroup.Text>
                                    </InputGroup>
                                    <Form.Text className="form-text">
                                        输入有效的充值兑换卡或者会员兑换卡
                                    </Form.Text>
                                </Form>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
        </Container>

    );
};

export default ExchangeCodes;